// Module
var code = "<div ref=\"darkDivLoader\" class='fad fa-spinner fa-pulse fa-8x'></div>\n<div ref=\"darkProgressText\"></div>\n<div ref=\"darkDivText\"></div>";
// Exports
module.exports = code;